export default "__VITE_ASSET__Cr8T46K8__"